import { Controller } from '@hotwired/stimulus';

// Shows the profile cards carousel and associated menu
//
export default class extends Controller {
  static targets = ['carousel', 'menu'];
  menuItems = null;
  bootstrapCarousel = null;
  carouselInterval = 8000;

  connect() {
    this.#initializeBootstrapCarousel();
    this.#initializeMenuItems();

    this.#setFirstAsActive();
    this.#changeHighlightedMenuItemOnCardSwitch();
    this.#changeCarouselItemOnMenuClick();
    this.#highlightActive(0);
  }

  #changeCarouselItemOnMenuClick() {
    [...this.menuItems].forEach((item, index) => {
      item.addEventListener('click', (_) => {
        this.#clearMenuHighlights();
        this.#goToCarouselCardAndResetTimer(index);
        this.#highlightActive(index);
      });
    });
  }

  #initializeBootstrapCarousel() {
    this.bootstrapCarousel = new bootstrap.Carousel(this.carouselTarget, { interval: this.carouselInterval, pause: false });
    this.bootstrapCarousel.cycle();
  }

  #initializeMenuItems() {
    this.menuItems = this.menuTarget.getElementsByClassName('carousel-menu-item');
  }

  #setFirstAsActive() {
    this.carouselTarget.querySelector('.carousel-item').classList.add('active');
  }

  // * Goes to the clicked card
  // * Also resets the carousel timer, so if a user clicks a new slide just before a transition, it doesn't transition again shortly after clicking
  #goToCarouselCardAndResetTimer(index) {
    this.bootstrapCarousel.pause();
    this.bootstrapCarousel.to(index);
    this.bootstrapCarousel._config.interval = this.carouselInterval;
    this.bootstrapCarousel.cycle();
  }

  #changeHighlightedMenuItemOnCardSwitch() {
    this.carouselTarget.addEventListener('slide.bs.carousel', (event) => {
      this.#clearMenuHighlights();
      this.#highlightActive(event.to);
    });
  }

  #clearMenuHighlights() {
    [...this.menuItems].forEach((item) => {
      item.classList.remove('active-item');
    });
  }

  #highlightActive(active_index) {
    this.menuItems[active_index].classList.add('active-item');
  }
}
